// extracted by mini-css-extract-plugin
export default {"createdAt":"style_createdAt__ffq2Y"};